import React from 'react';
import BookingCalendar, {
    BookingCalendarProps
} from '~components/AdServiceBooking/BookingCalendar';
import { ChatServiceContextWrapper } from '@olxeu-u2u/chat-react-js-sdk/dist/integration/ChatServiceContextWrapper';
import { AppProps } from '~widgetComponents/BookingPanelPage';
import { IntlProvider } from '@olxpwa-lib/i18n/client';
import { mapLocaleToTranslations } from '~i18n/mapLocaleToTranslations';
import { AppContextProvider } from '~state/App.context';
import { ErrorBoundary } from '~components/errors';
import CoreThemeProvider from '@olxui/core/dist/theme/CoreTheme/CoreThemeProvider';

type ServiceBookingCalendarTypes = Omit<BookingCalendarProps, 'platform'> &
    Omit<AppProps, 'routerBasePath' | 'adId'> & {
        sendHotjarEvent: (name: string) => void;
    };

const ServiceBookingCalendarWidget = ({
    appConfig,
    PWAutils,
    getAuthToken,
    tracker,
    authenticated,
    ad,
    user,
    chatApiConfig,
    sendHotjarEvent,
    renderBookingSubmitMobile,
    SFCUtils
}: ServiceBookingCalendarTypes) => {
    const { platform, locale } = appConfig;
    return (
        <CoreThemeProvider>
            <ErrorBoundary>
                <IntlProvider
                    messages={mapLocaleToTranslations[locale]}
                    locale={locale}
                >
                    <AppContextProvider
                        value={{
                            appConfig,
                            PWAutils,
                            getAuthToken,
                            tracker,
                            authenticated,
                            adId: ad.id,
                            sendHotjarEvent,
                            SFCUtils
                        }}
                    >
                        <ChatServiceContextWrapper
                            chatServiceConfig={chatApiConfig}
                        >
                            <BookingCalendar
                                ad={ad}
                                platform={platform}
                                user={user}
                                renderBookingSubmitMobile={
                                    renderBookingSubmitMobile
                                }
                            />
                        </ChatServiceContextWrapper>
                    </AppContextProvider>
                </IntlProvider>
            </ErrorBoundary>
        </CoreThemeProvider>
    );
};

export default ServiceBookingCalendarWidget;
